/** Miliseconds */
export const GENERAL_DURATION = 300
